const SHOWING_CLASS = 'showing';
const READY_CLASS = 'flip-ready';

class FlipperPanel {
	constructor(element) {
		this.element = element;
	}
	
	flipIn() {
		this.element.classList.add(SHOWING_CLASS);
	}
	
	flipOut() {
		this.element.classList.remove(SHOWING_CLASS);
	}
}

class FlipperController {
	constructor(element) {
		// Bail if no element
		this.element = typeof(element) === 'string' ? document.querySelector(element) : element;
		if (this.element === null) return;
		
		this.panels = [];
		this.currentPanel = null;
		
		// Collect the children as panels
		for (const child of this.element.children) {
			const panel = new FlipperPanel(child);
			this.panels.push(panel);
			if (child.classList.contains(SHOWING_CLASS)) {
				this.currentPanel = panel;
			}
		}
		
		// Set first panel as current if no `currentPanel`
		// was specified in the markup code.
		if (this.currentPanel === null) {
			this.flipTo(this.panels[0]);
		}
		
		this.attachEventHandlers();
		this.onFlipperReady();
	}
	
	flip() {
		let index = 1 + this.panels.indexOf(this.currentPanel);
		if (index >= this.panels.length) index = 0;
		this.flipTo(this.panels[index]);
	}
	
	flipTo(activePanel) {
		if (activePanel) {
			if (this.currentPanel !== null) {
				this.currentPanel.flipOut();
			}
			activePanel.flipIn();
			// Set `activePanel` as the new `currentPanel`
			this.currentPanel = activePanel;
		}
	}
	
	onFlipperReady() {
		this.element.classList.add(READY_CLASS);
	}
	
	attachEventHandlers() {
		this.element.addEventListener('click', (event) => {
			const target = event.target;
			if (target.classList.contains('flip-next')) {
				this.flip();
			}
		});
	}
}
